import {Button} from "antd";
import {Picker} from "antd-mobile";
import {useMemo, useState} from "react";
import {PickerValue} from "antd-mobile/es/components/picker-view";
import {BrowserView, MobileView} from "react-device-detect";
import LuxonTimePicker, {LuxonTimePickerProps} from "./LuxonTimePicker";
import { DateTime } from "luxon";

const TIME_FORMAT = "HH:mm";

export default function AdaptiveTimePicker(props: LuxonTimePickerProps) {
  const [mobileVisible, setMobileVisible] = useState(false);

  const value = useMemo(() => {
    if (!props.value) return ["00", "00"];
    return [
      props.value.toFormat("HH") || "00",
      props.value.toFormat("mm") || "00",
    ];
  }, [props.value]);

  const handleOnChange = (val: PickerValue[]) => {
    const formattedTime = `${val[0]}:${val[1]}`;
    const timeObject = DateTime.fromFormat(formattedTime, TIME_FORMAT);
    props.onChange?.(timeObject, timeObject.toFormat(TIME_FORMAT));
  };

  const columns = [
    Array.from({length: 24}, (_, i) => ({
      label: i.toString().padStart(2, "0"),
      value: i.toString().padStart(2, "0"),
    })),
    Array.from({length: 60}, (_, i) => ({
      label: i.toString().padStart(2, "0"),
      value: i.toString().padStart(2, "0"),
    })),
  ];

  const handleSetNow = () => {
    const now = DateTime.now();
    props.onChange?.(now, now.toFormat(TIME_FORMAT));
    setMobileVisible(false);
  }

  return (
    <>
      <BrowserView>
        <LuxonTimePicker {...props} format={TIME_FORMAT}/>
      </BrowserView>

      <MobileView>
        <Picker
          title={(
            <Button
              color='blue'
              variant='link'
              onClick={handleSetNow}
            >
              Now
            </Button>
          )}
          columns={columns}
          value={value}
          visible={mobileVisible}
          onClose={() => setMobileVisible(false)}
          onConfirm={(val) => {
            handleOnChange(val);
            setMobileVisible(false);
          }}
          onCancel={() => setMobileVisible(false)}
          confirmText='Confirm'
          cancelText='Close'
        />

        <LuxonTimePicker
          {...props}
          inputReadOnly
          format={TIME_FORMAT}
          popupStyle={{display: "none"}}
          onClick={() => setMobileVisible(true)}
        />
      </MobileView>
    </>
  );
}
